export default "__VITE_ASSET__CDLCR8$y__"